/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Shoes(props) {
    return (
        <SvgIcon {...props}>
            <g>
                <path d="M4.673,7.601c-0.073-0.033-0.15-0.039-0.228-0.017c-0.222,0.073-1.078,0.3-1.339,0.3 c-1.4,0-2.222-1.189-2.233-1.2c-0.072-0.05-0.167-0.067-0.25-0.05c-0.089,0.022-0.161,0.078-0.2,0.156 c-0.705,1.372-0.167,2.778-0.027,3.094v1.828c0,0.072,0.017,0.184,0.011,0.289c0.123,0,0.195,0,0.289,0h1.373 c0.083,0,0.211,0,0.305,0c0-0.094,0-0.228-0.005-0.306l-0.067-1.411c0.8-0.078,1.711,1.123,1.978,1.572 C4.334,11.945,4.434,12,4.54,12h4.739c0.111,0,0.216-0.061,0.267-0.155c0.389-0.717,0.45-1.333,0.316-1.739 C7.262,9.023,4.673,7.601,4.673,7.601z" />
                <path d="M0.712,5.662h8.7c0.133,0,0.25-0.089,0.289-0.211c0.072-0.233,0.667-2.3-0.05-3.2 C9.557,2.134,9.39,2.101,9.256,2.178C9.246,2.184,7.929,2.951,6.845,2.951c-0.35,0-0.628-0.078-0.839-0.245V2.428 c0-0.094,0-0.267-0.005-0.428C5.851,2.062,5.69,2.123,5.595,2.156c-1.066,0.406-2.383,0.911-4.883,1.45 C0.679,3.611,0.54,3.65,0.479,3.689C0.356,3.762,0.118,3.878,0.023,4.351c-0.072,0.378,0.006,0.767,0.461,1.206 C0.545,5.617,0.623,5.662,0.712,5.662z" />
            </g>
        </SvgIcon>
    );
}

Shoes.defaultProps = {
    viewBox: '0 0 10.001 16'
};

export default Shoes;
